import { Button } from "reactstrap";
import React, { useEffect, useState } from "react";
import ModalWrapper from "Components/Modals/ModalWrapper";
import { MediaItem } from "./ImageGallery";

interface EditModalProps {
    isOpen: boolean;
    toggle: () => void;
    media: MediaItem;
    onSave: (id : number) => void;
  }

function EditModal({ isOpen, toggle, onSave, media }: EditModalProps) {

  const [isFeatured, setIsFeatured] = useState<boolean>(media?.is_featured === 1);

  useEffect(() => {
    setIsFeatured(media?.is_featured === 1);
  }, [media]);

  return (
    <ModalWrapper
      show={isOpen}
      onCloseClick={toggle}
      title="Mark Media as Featured"
      body={
        <>
        <div className="mx-auto mb-3 d-flex justify-content-center">
          <img src={media?.file_url || ""} alt="Selected Media" className="avatar-xl rounded h-100" />
        </div>

        <div className="d-flex justify-content-center">
          <label className="form-check-label" htmlFor="featuredCheckbox">
            Mark as Featured
          </label>
          <input
            type="checkbox"
            className="form-check-input ms-2"
            id="featuredCheckbox"
            checked={isFeatured}
            onChange={(e) => {
              // Only allow checking, prevent unchecking
              if (e.target.checked) {
                setIsFeatured(true);
              }
            }} 
          />
        </div>
       
        <div className="d-flex gap-2 justify-content-end mt-4">
          <Button color="secondary" onClick={toggle}>Cancel</Button>
          <Button color="success" onClick={() => onSave(media?.id)}>Save</Button>
        </div>
        </> 
      }
    />
  );
}

export default EditModal